"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectMainColor = detectMainColor;
exports.radius = radius;
exports.Button = void 0;

var _reactNative = require("react-native");

var _native = _interopRequireWildcard(require("styled-components/native"));

var _styledUtils = require("@sloth-system/styled-utils");

var _props = require("@sloth-system/props");

var _ButtonHelpers = require("./Button-helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function detectMainColor(prefferedColor = "primary") {
  return function (props) {
    let mainColor = props.disabled ? "neutrals.300" : `${prefferedColor}.main`;
    return (0, _styledUtils.color)(mainColor);
  };
}

function radius() {
  return function (props) {
    let borderRadius = props.radius ? props.radius : "xm";
    return (0, _styledUtils.radii)(borderRadius);
  };
}

function findAndMakeTransparentColor(prefferedColor) {
  return function (props) {
    return (0, _ButtonHelpers.hexToRgbA)((0, _styledUtils.color)(prefferedColor)(props), "0.3");
  };
}

let fillVariant = (0, _props.variant)("fill", {
  primary: (0, _native.css)`
    background-color: ${detectMainColor("primary")};
    border-radius: ${radius()};
  `,
  secondary: (0, _native.css)`
    background-color: ${detectMainColor("secondary")};
    border-radius: ${radius()};
  `,
  white: (0, _native.css)`
    background-color: ${props => {
    return `${props.theme.color.common.white}`;
  }};
    border-radius: ${radius()};
  `,
  transparent: (0, _native.css)``,
  transparentWhite: (0, _native.css)`
    background-color: ${findAndMakeTransparentColor("common.white")};
    border-radius: ${(0, _styledUtils.radii)("l")};
  `
});
let outlineVariant = (0, _props.variant)("outline", {
  primary: (0, _native.css)`
    border-radius: ${radius()};
    border: 1px solid ${detectMainColor("primary")};
  `,
  secondary: (0, _native.css)`
    border-radius: ${radius()};
    border: 1px solid ${detectMainColor("secondary")};
  `
});
let sizeVariant = (0, _props.variant)("size", {
  s: (0, _native.css)`
    padding-top: ${(0, _styledUtils.space)("s")};
    padding-bottom: ${(0, _styledUtils.space)("s")};
    padding-left: ${(0, _styledUtils.space)("m")};
    padding-right: ${(0, _styledUtils.space)("m")};
  `,
  m: (0, _native.css)`
    padding-top: ${(0, _styledUtils.space)("m")};
    padding-bottom: ${(0, _styledUtils.space)("m")};
    padding-left: ${(0, _styledUtils.space)("l")};
    padding-right: ${(0, _styledUtils.space)("l")};
  `,
  l: (0, _native.css)`
    padding-top: ${(0, _styledUtils.space)("l")};
    padding-bottom: ${(0, _styledUtils.space)("l")};
    padding-left: ${(0, _styledUtils.space)("xl")};
    padding-right: ${(0, _styledUtils.space)("xl")};
  `
});
let buttonWebStyles = "";

if (_reactNative.Platform.OS === "web") {
  buttonWebStyles = `display: block !important;`;
}

let Button = _native.default.TouchableOpacity`
  ${buttonWebStyles}
  ${sizeVariant}
  ${fillVariant}
  ${outlineVariant}
`;
exports.Button = Button;